import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TJ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#TJ_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v24H0V0z", fill: "#F7FCFF" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0z", fill: "#C51918" }), /* @__PURE__ */ e.createElement("path", { d: "M0 16v8h32v-8H0z", fill: "#409100" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.02 8.63l-.592.418.208-.7-.573-.442.72-.015.236-.69.237.69.72.015-.574.442.208.7-.59-.418zm-2.497.612l-.591.418.208-.7-.574-.442.72-.015.237-.69.236.69.72.015-.573.442.208.7-.591-.418zM10.988 11.5l.592-.418.59.418-.208-.7.574-.442-.72-.015-.236-.69-.237.69-.72.015.574.442-.209.7zm-.031 1.965l-.592.418.209-.7L10 12.74l.72-.015.237-.69.236.69.72.015-.574.442.209.7-.591-.418zm9.465.418l.591-.418.591.418-.208-.7.574-.442-.72-.015-.237-.69-.236.69-.72.015.574.442-.209.7zm-.17-2.8l-.592.417.209-.7-.574-.442.72-.015.236-.69.237.69.72.015-.574.442.209.7-.591-.418zM17.745 9.66l.591-.418.592.418-.209-.7.574-.442-.72-.015-.237-.69-.236.69-.72.015.574.442-.209.7zm-5.08 7.095l-.184-.656c1.02-.276 2.191-.414 3.514-.414 1.322 0 2.493.138 3.513.414l-.184.656c-.957-.258-2.066-.389-3.33-.389-1.263 0-2.372.13-3.329.39zm1.265-1.053c-.407.07-.74-.324-.74-.324l.404-.167a.646.646 0 01.156-.453c.136.063.323.406.323.406h.366s-.102.47-.51.538zm4.809-.256s-.333.394-.74.325c-.407-.07-.509-.538-.509-.538h.366s.186-.344.323-.407c0 0 .169.174.156.454l.404.166zm-2.795.131c-.413.012-.688-.424-.688-.424l.423-.109a.646.646 0 01.218-.427c.126.081.263.448.263.448l.362.05s-.166.45-.579.462z",
      fill: "#FB0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.96 13.699s-.47 1.073-1.208 1.156c-.739.083-1.114-.61-1.114-.61s-.049.72-.926.999c-.877.278-1.339-.833-1.339-.833s.457.409 1.165.23c.708-.177.988-.835.988-.835s.524.686 1.226.343c.701-.343 1.089-.762 1.089-1.163v-1.202s-.18-.312-.495-.312c-.314 0-.401.22-.401.22s-.123-1.25 1.006-1.327v-.003l.031.002.032-.002v.003c1.128.078 1.006 1.328 1.006 1.328s-.088-.221-.402-.221c-.313 0-.494.312-.494.312v1.201c0 .402.388.821 1.089 1.164.701.343 1.226-.343 1.226-.343s.28.658.988.836c.708.178 1.165-.23 1.165-.23s-.462 1.11-1.34.832c-.877-.278-.925-1-.925-1s-.375.694-1.114.611c-.739-.083-1.208-1.156-1.208-1.156l-.023-1.417-.023 1.417zm-.011-2.997c-.521 0-.627.441-.627.441.459 0 .627.2.627.2s.34-.2.681-.2c0 0-.16-.44-.681-.44z",
      fill: "#FB0"
    }
  ))
), c = t;
export {
  c as default
};
